import React from 'react';
import { Label } from './label';
import { ControllerRenderProps, FieldValues, Path } from 'react-hook-form';
import clsx from 'clsx';
import { Textarea } from './textarea';

interface ControllerTextareaProps<FieldsType extends FieldValues> {
  title?: string;
  titleIcon?: React.ReactNode;
  name?: string;
  field: ControllerRenderProps<FieldsType, Path<FieldsType>>;
  placeholder?: string;
  errorMessage?: string;
  disabled: boolean;
  icon?: React.ReactNode;
  rows?: number;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const ControllerTextarea = <FieldsType extends FieldValues>({
  title,
  titleIcon,
  field: { value, ...otherFieldValues },
  name,
  placeholder,
  errorMessage,
  disabled,
  icon,
  rows,
  onChange,
}: ControllerTextareaProps<FieldsType>) => (
  <>
    {(title || titleIcon) && (
      <div className="flex justify-between">
        <Label
          className="text-gray-700 transition-all duration-200 ease-in-out"
          htmlFor={`textarea-${name}`}
        >
          {title}
        </Label>
        {titleIcon}
      </div>
    )}
    <div className="relative flex items-center">
      <div className="absolute left-3 pointer-events-none">{icon && icon}</div>
      <Textarea
        id={`textarea-${name}`}
        value={value ?? ''}
        {...otherFieldValues}
        disabled={disabled}
        placeholder={placeholder}
        className={clsx(
          'rounded-lg border-gray-300 gap-2 text-gray-900 placeholder-gray-500 disabled:placeholder-gray-100 focus-visible:outline-hidden focus-visible:shadow-active focus-visible:ring-offset-2 focus-visible:border-brand-300 disabled:bg-gray-100 md:text-base',
          {
            'border-error-300': errorMessage,
            'pl-10': icon,
          },
        )}
        rows={rows}
        onChange={onChange}
      />
    </div>
  </>
);

export default ControllerTextarea;
